import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Patient } from "../../interfaces/api/patients";
import { Trash } from "lucide-react";

interface PatientColumnHandlers {
  onDelete: (patient: Patient) => void;
}

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } catch (error) {
    return dateString;
  }
};

const getActionButtonClasses = (type: string) => {
  const baseClasses = "p-2 rounded-full transition-colors duration-200";
  switch (type) {
    case "delete":
      return `${baseClasses} text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-500/10`;
    default:
      return `${baseClasses} text-gray-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-500/10`;
  }
};

export const getPatientsTableColumns = (
  handlers: PatientColumnHandlers,
): TableColumnsItem[] => [
  {
    key: "fullName",
    name: "Patient Name",
    type: ColumnType.CUSTOM,
    width: "220px",
    cardTitle: true,
    customValue: (row: Patient) => `${row.first_name} ${row.last_name}`.trim(),
    customCellClass: "font-medium text-gray-900 dark:text-gray-100",
  },
  {
    key: "dob",
    name: "DOB",
    type: ColumnType.CUSTOM,
    width: "120px",
    cardOrder: 1,
    customValue: (row: Patient) => formatDate(row.dob),
    customCellClass: "text-gray-600 dark:text-gray-400",
  },
  {
    key: "gender",
    name: "Gender",
    type: ColumnType.TEXT,
    width: "100px",
    cardOrder: 2,
    customCellClass: "text-gray-600 dark:text-gray-400",
  },
  {
    key: "mobile_number",
    name: "Phone",
    type: ColumnType.TEXT,
    width: "140px",
    cardOrder: 3,
    customCellClass: "text-gray-600 dark:text-gray-400",
  },
  {
    key: "email",
    name: "Email",
    type: ColumnType.TEXT,
    width: "220px",
    cardOrder: 4,
    customCellClass: "text-gray-600 dark:text-gray-400",
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    width: "100px",
    cardOrder: 999,
    buttonsList: [
      {
        type: ButtonType.ICON,
        onPress: (e: React.MouseEvent, row: Patient) => {
          e.stopPropagation();
          handlers.onDelete(row);
        },
        cssClass: getActionButtonClasses("delete"),
        icon: Trash,
      },
    ],
  },
];
